import { memo } from "react";

const TitleHeader = ({item, onNavigatePDP, isMapCard, isGridOrList}) => {
  const {propAddress} = item;
  const location1 = `${propAddress?.streetNumber}${propAddress?.streetName?.trim() !== '' ? ` ${propAddress?.streetName}` : ''}`;
  const location2 = `${propAddress?.city}, ${propAddress?.state} ${propAddress?.zip}`;
  return (
    <>
      {!item.isPreview && item?.category !== 'FORECLOSURE' && item?.category !== 'NPL' && item?.agentCompanyName && !isMapCard ? (
        <div className={`list-inline-item head number_of_line_one ${isGridOrList ? 'pt5' : ''}`} tabIndex="0">LISTED BY {item?.agentCompanyName?.toUpperCase()}</div>
      ) : <div style={{paddingTop: isMapCard ? 0 : 18}}>{' '}</div>}
      {item?.type && <p className="text-thm">{item?.type}</p>}
      <div className="cardTitle" onClick={onNavigatePDP} tabIndex="0">
        <span className={`${isMapCard ? 'headTitleM' : 'headTitle'} number_of_line_one`} style={{paddingTop: isGridOrList ? 0 : 2, marginBottom: isGridOrList ? 0 : -2}}>{' '}{location1} </span>
        <span className={`${isMapCard ? 'headTitleM' : 'headTitle'} number_of_line_one`} style={{paddingTop: isGridOrList ? 0 : 2, marginBottom: isGridOrList ? 0 : -2}}>{' '}{location2} </span>
      </div>
    </>
  );
};

export default memo(TitleHeader);
